"use strict";

class elementReady {

    constructor($timeout) {
        return function(selector) {
            return new Promise(resolve => {
                let checkElement = function() {
                    let elements = angular.element(selector);
                    if(elements.length == 0) {
                        $timeout(checkElement, 20)
                    } else {
                        resolve(elements);
                    }
                };

                checkElement();
            })
        };
    }
}

elementReady.$inject = ['$timeout'];

module.exports = elementReady;